import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["form"]
    static values = {
        "basePath": String
    }

    changeFormAction(e) {
        this.formTarget.setAttribute('action', this.basePathValue + e.params.var + '/#result')
    }
}